// Interfaces
import { IBaseWrapperProps } from './interfaces'

// Constant
import { LAYOUT } from 'constant/layout.constant'

// Components
import { LayoutAuth, LayoutBackOffice, LayoutDefault, LayoutEmpty, LayoutPublic, LayoutAccount } from 'components'

const BaseWrapper = ({ children, layout, meta }: IBaseWrapperProps) => {
  switch (layout) {
    case LAYOUT.AUTH:
      return <LayoutAuth meta={meta}>{children}</LayoutAuth>
    case LAYOUT.DEFAULT:
      return <LayoutDefault>{children}</LayoutDefault>
    case LAYOUT.EMPTY:
      return <LayoutEmpty>{children}</LayoutEmpty>
    case LAYOUT.PUBLIC:
      return <LayoutPublic>{children}</LayoutPublic>
    case LAYOUT.BACK_OFFICE:
      return <LayoutBackOffice meta={meta}>{children}</LayoutBackOffice>
    case LAYOUT.ACCOUNT:
      return <LayoutAccount>{children}</LayoutAccount>
    default:
      return <>{children}</>
  }
}

export { BaseWrapper }
